import { Component, Output, EventEmitter } from '@angular/core';
import { UsersService } from '@app/shared/services/users.service';
import { PhotoService } from '@app/shared/services/photo.service';
import { AlertService } from '@app/shared/services/alert.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { SessionService } from '@app/shared/services/session.service';
declare var UIkit: any;
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent {

  public user : any = {
    email: '',
    gender: 'male',
    password: '',
    firstName: '',
    lastName: '',
    mobile: '',
    age: ''
  };
  public passwordConfirmation: string = '';
  public loadingAccountCreation: boolean = false;
  public page: number = 1;

  public idRecto : any = null;
  public idVerso : any = null;
  public drivingRecto : any = null;
  public drivingVerso : any = null;
  public validated : boolean = false;

  public loading : boolean = false;
  @Output() changed = new EventEmitter();

  public societies: Array<any> = [];
  public selectedSocietyId: number = 0;

  constructor(
    private userService: UsersService,
    private photoService: PhotoService,
    private alertService: AlertService,
    public session: SessionService,

    private societyService: SocietiesService
  ) {}

  ngOnInit() {
    if (this.session.role.ability === 'super-admin') {
      this.societyService.updateSocieties(1, "").then((res) => {
        this.societies = res;
      });
    }
  }

  resetVariables() {
    this.user = {
      email: '',
      gender: 'male',
      password: '',
      firstName: '',
      lastName: '',
      mobile: '',
      age: ''
    };
    this.selectedSocietyId = 0;
    this.page = 1;
    this.passwordConfirmation = ""
    this.validated = false;
  }
  
  modifyPhoto(part) : void {
    this.photoService.askFile().then((photo) => {
      switch (part) {
        case 1:
          this.drivingRecto = photo;
          break;
        case 2:
          this.drivingVerso = photo;
          break;
        case 3:
          this.idRecto = photo;
          break;
        case 4:
          this.idVerso = photo;
          break;
      }
    });
  }

  errorHandling(): number {
    if (this.loadingAccountCreation === true) {
      return 1;
    }
    if (this.passwordConfirmation !== this.user.password) {
      this.alertService.error('Les mots de passe sont différents.');
      return 1;
    }
    if (this.user.email.includes('@') === false || this.user.email.includes('.') === false) {
      this.alertService.error("L'adresse e-mail est invalide.");
      return 1;
    }
    return 0;
  }

  cancelPhoto(part) : void {
    switch (part) {
      case 1:
        this.drivingRecto = null;
        break;
      case 2:
        this.drivingVerso = null;
        break;
      case 3:
        this.idRecto = null;
        break;
      case 4:
        this.idVerso = null;
        break;
    }
  }

  nextPage(): number {
    if (this.page === 1) {

      if (this.user.email === '' || this.user.password === '' || this.user.firstName === '' || this.user.lastName === '' || this.user.age === '' || this.user.mobile === '') {
        this.alertService.error("Veuillez remplir tous les champs.");
        return 1;
      }

      if (this.session.role.ability === 'super-admin' && this.selectedSocietyId === 0) {
        this.alertService.error("Veuillez sélectionner un opérateur.");
        return 1;
      }

      return 0;
    }
    return 0;
  }

  prevPage(): number {
    if (this.page === 2) {
      this.page = 1;
      return 1;
    }
    return 0;
  }

  register(): void {
    if (this.errorHandling() === 1) { return; }
    if (this.nextPage() === 1) { return; }

    const idSocietyVop = this.session.role.ability === 'super-admin'
      ? this.selectedSocietyId
      : this.session.role.id;

    this.loadingAccountCreation = true;
    this.userService.registerUser(this.user, {
      identityCardBack: this.idVerso,
      identityCardFront: this.idRecto,
      drivingLicenseFront: this.drivingRecto,
      drivingLicenseBack: this.drivingVerso
    }, idSocietyVop).then((res: any) => {
      if (res.error && res.error.result_code === 2) {
        this.alertService.error("Adresse e-mail déjà utilisé.");
      }
      if (res.body && res.body.result_code === 0) {
        this.alertService.alert("Le compte a été créé.");
        this.changed.emit(null);
        this.resetVariables();
        UIkit.modal('#add-user').hide();
      }
      this.loadingAccountCreation = false;
    });
  }

}
